import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../../services/redux/authSlice";
import tokenApi from "../../../services/apiServices/tokenApi"; // Adjust the path based on your project structure
import "./LoginPage.css";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { setLoading } from "../../../services/redux/loadingSlice";
import { formatIdentifier, normalizeIdentifier } from "../../../components/masks/masks";
import MessageModal from "../../../components/common/Modals/MessageModal/MessageModal";
import configService from "../../../services/configService";

const LoginPage = () => {
    const [identifier, setIdentifier] = useState(""); // For email (admin) or CPF/CNPJ (client)
    const [orderNumber, setOrderNumber] = useState(""); // For client login
    const [password, setPassword] = useState(""); // For admin login
    const [error, setError] = useState("");
    const [isMessageOpen, setIsMessageOpen] = useState(false);
    const [message, setMessage] = useState(false);
    const dispatch = useDispatch();

    const openMessageModal = () => {
        setIsMessageOpen(true);
    };

    const closeMessageModal = () => {
        setIsMessageOpen(false);
    };

    const isAdmin = window.location.pathname.includes("admin"); // Check if URL contains 'admin'

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            dispatch(setLoading(true));

            const payload = isAdmin
                ? { username: identifier, password: password }
                : { document: formatIdentifier(identifier), order: orderNumber };

            const response = await tokenApi.getToken(payload);

            if (response.code) {
                setMessage(response.message);
                openMessageModal();
            } else {
                dispatch(
                    login({
                        access_token: response.access_token,
                        persontypecode: isAdmin
                            ? configService.getAdminPersonTypeCode()
                            : configService.getClientPersonTypeCode(),
                        name: response.name,
                        code: response.id,
                        orderNumber: isAdmin ? null : orderNumber,
                    })
                );
            }
        } catch (err) {
            setError("Falha na autenticação. Verifique seus dados e tente novamente.");
            console.error("Login failed:", err);
        } finally {
            dispatch(setLoading(false));
        }
    };

    return (
        <div className="page">
            <MessageModal isOpen={isMessageOpen} click={closeMessageModal} message={message} />
            <PageTitle title="Autenticação" />
            <p className="login-description">
                {isAdmin
                    ? "Informe seu email e senha para acessar o painel administrativo:"
                    : "Informe os dados para visualizar a solicitação de pedido:"}
            </p>
            <form className="login-form" onSubmit={handleSubmit}>
                <div className="login-form-group">
                    <label htmlFor="identifier" className="login-label">
                        {isAdmin ? "Email" : "CPF/CNPJ"}
                    </label>

                    <input
                        type={isAdmin ? "email" : "text"}
                        id="identifier"
                        className="login-input"
                        value={isAdmin ? identifier : formatIdentifier(identifier)}
                        maxLength={isAdmin ? 255 : 18}
                        onChange={(e) =>
                            setIdentifier(
                                isAdmin ? e.target.value : normalizeIdentifier(e.target.value)
                            )
                        }
                        placeholder={isAdmin ? "Digite seu email" : "Digite seu CPF ou CNPJ"}
                        required
                    />
                </div>
                {!isAdmin && (
                    <div className="login-form-group">
                        <label htmlFor="orderNumber" className="login-label">Pedido</label>
                        <input
                            type="text"
                            id="orderNumber"
                            className="login-input"
                            value={orderNumber}
                            onChange={(e) => setOrderNumber(e.target.value)}
                            placeholder="000000"
                            required
                        />
                    </div>
                )}
                {isAdmin && (
                    <div className="login-form-group">
                        <label htmlFor="password" className="login-label">Senha</label>
                        <input
                            type="password"
                            id="password"
                            className="login-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Digite sua senha"
                            required
                        />
                    </div>
                )}
                {error && <p className="error-message">{error}</p>}
                <button type="submit" className="main-button">Acessar</button>
            </form>
        </div>
    );
};

export default LoginPage;
